/* eslint-disable no-console */

const updateShopifyCustomerTags = (customerId, tags) => {
  const gId = `gid://shopify/Customer/${customerId}`;

  const mutation = `
    mutation customerUpdate($input: CustomerInput!) {
      customerUpdate(input: $input) {
        userErrors {
          field
          message
        }
        customer {
          id
          tags
        }
      }
    }
  `;

  const variables = {
    input: {
      id: gId,
      tags,
    },
  };

  return fetch('https://us3.apis.kimclark.com/kcc-thinx-pxy-api/admin/api/2025-01/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      uauthorization:
        'Basic MG9hMTVzbm9vNGlyZDM2NWcxdDg6c0s5Nk05UUVBRk4xMFZNRnowV1B5cXltMVBnckxNMFBOVHhhWnNZODM1eHJUNFFkSVQtdXhjVi1OQ1Q3SU44UQ==',
    },
    body: JSON.stringify({ query: mutation, variables }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.errors) {
        console.error('GraphQL errors:', data.errors);
        throw new Error('Error updating customer');
      } else {
        console.log('Customer updated');
        return data;
      }
    })
    .catch((error) => {
      console.error('Error updating customer:', error);
      throw error;
    });
};

export default updateShopifyCustomerTags;
